/* Mahi Wairua — Gift Finder.
   Recommends products from the live catalogue. Prices come from available variants only
   (rendered by Shopify at request time); unavailable products are never shown. */
(function (root) {
  'use strict';
  const has = (s, re) => re.test(s);

  // Describe a product with simple facets from its type, title, tags and collections.
  function facets(p) {
    const title = (p.t || '').toLowerCase(), type = (p.ty || '').toLowerCase();
    const tags = (p.tg || []).join(' | ').toLowerCase(), cols = (p.c || []).join(' ');
    const all = title + ' | ' + type + ' | ' + tags;
    const f = new Set();
    if (has(type, /mirror/)) f.add('mirror');
    if (has(type, /clock/) && has(title, /clock/)) f.add('clock');
    if (has(type, /metal|canvas|print|wall art/) || has(title, /metal (photo )?print|wall art|canvas print/)) f.add('art');
    if (has(type, /personalised/) || has(tags, /mahi-print-personalisation|custom-photo-print|personalised-metal-prints/) || has(title, /personalised|custom moko/)) f.add('personalised');
    if (has(type, /t-shirt/) || has(title, /t-shirt|\btee\b|tees\b/)) f.add('tee');
    if (has(type, /hoodie|sweatshirt/) || has(title, /hoodie|sweatshirt|\bcrew\b/)) f.add('warm');
    if (has(type, /sunglasses/)) f.add('sunglasses');
    if (has(type, /leggings/)) f.add('activewear');
    if (has(type, /serving board/)) f.add('board');
    if (has(title, /\bkids?\b|tamariki|fantasy adventure/) || has(cols, /kids/)) f.add('kids');
    if (has(title, /adults? & kids|adults and kids/)) f.add('family-sizes');
    if (has(all, /rugby league|supporter|warriors|kiwis|\bjfh\b|toa samoa|kumuls|bati|mate ma'a/)) f.add('league');
    if (has(title, /wh[aā]nau|family|whakapapa|t[oō]ku whenua|portrait & wh/)) f.add('whanau');
    if (has(title, /couple|king & queen|wedding|anniversary/)) f.add('couple');
    if (has(title, /wedding/)) f.add('wedding');
    if (has(title, /anniversary/)) f.add('anniversary');
    if (has(title, /birthday|21st/)) f.add('birthday');
    if (has(title, /memorial/)) f.add('memorial');
    if (has(title, /pet/)) f.add('pet');
    if (has(title, /karakia|whakatauk[iī]/)) f.add('words');
    if (has(title, /matariki|t[uū][iī]|k[aā]rearea|kerer[uū]|kiwi of aotearoa|p[oō]hutukawa|pīwakawaka/)) f.add('nature');
    if (has(title, /\bmoko\b|wahine|wāhine/)) f.add('wahine');
    if (has(title, /embroidered/)) f.add('embroidered');
    if (f.has('kids') && !f.has('family-sizes')) f.add('kids-only');
    // Merchandise made for one group or crew is not a general gift suggestion.
    if (has(title, /kapa haka|scaff gang/)) f.add('group-merch');
    if (has(cols, /gifts-taonga|birthday-milestone-gifts/) || has(tags, /gift/)) f.add('giftable');
    return f;
  }

  // Weights: how well each facet suits an answer. Products need a positive score from "who".
  const WHO = {
    whanau: { whanau: 6, 'family-sizes': 3, personalised: 3, art: 2, words: 2, nature: 1, giftable: 1 },
    partner: { couple: 6, mirror: 3, personalised: 2, art: 2, warm: 2, embroidered: 2, wahine: 1, giftable: 1 },
    elder: { whanau: 5, words: 4, memorial: 2, mirror: 3, clock: 3, art: 2, personalised: 2, giftable: 1 },
    kids: { 'kids-only': 8, kids: 2, 'family-sizes': 4 },
    friend: { tee: 3, warm: 2, sunglasses: 3, clock: 2, art: 2, board: 2, giftable: 2 },
    fan: { league: 8 },
    self: { art: 2, mirror: 2, tee: 2, warm: 2, clock: 2, personalised: 1, sunglasses: 1, activewear: 1, board: 1 }
  };
  const OCCASION = {
    any: {},
    birthday: { birthday: 6, personalised: 2, tee: 1, warm: 1, mirror: 1, giftable: 2 },
    wedding: { wedding: 6, anniversary: 5, couple: 5, mirror: 2, personalised: 2 },
    home: { art: 3, mirror: 4, clock: 4, words: 3, whanau: 2, nature: 2, board: 2 },
    memorial: { memorial: 8, pet: 2, words: 4, whanau: 2 },
    christmas: { giftable: 3, tee: 1, warm: 2, art: 1, mirror: 1, clock: 1, kids: 1 },
    gameday: { league: 8 }
  };
  // Occasions that only make sense for certain products.
  const OCCASION_REQUIRES = { memorial: ['memorial', 'words', 'whanau', 'pet'], wedding: ['wedding', 'anniversary', 'couple', 'mirror', 'art'], gameday: ['league'], home: ['art', 'mirror', 'clock', 'board', 'words'] };

  function score(f, who, occasion) {
    const w = WHO[who] || {}, o = OCCASION[occasion] || {};
    let sw = 0, so = 0;
    f.forEach(k => { sw += w[k] || 0; so += o[k] || 0; });
    if (f.has('group-merch')) return 0;
    if (sw <= 0) return 0;
    const req = OCCASION_REQUIRES[occasion];
    if (req && !req.some(k => f.has(k))) return 0;
    // Tamariki and fan answers are strict; kids' items are not shown for other recipients unless sized for the family.
    if (who !== 'kids' && f.has('kids-only') && !f.has('whanau')) sw -= 4;
    // Supporter tees suit league fans and game day; elsewhere they rank below general gifts.
    if (f.has('league') && who !== 'fan' && occasion !== 'gameday') sw -= 3;
    if (sw <= 0) return 0;
    return sw + so;
  }

  // Orderable options as [priceInCents, variantId], lowest price first. Accepts the older "pr" price list too.
  function options(p) {
    if (Array.isArray(p.pv)) return p.pv.filter(o => Array.isArray(o) && o[0] >= 0).slice().sort((a, b) => a[0] - b[0]);
    return (p.pr || []).map(c => [c, null]).sort((a, b) => a[0] - b[0]);
  }
  // Prices are in cents. Returns orderable options inside the budget, lowest first.
  function optionsInBudget(opts, lo, hi) {
    return opts.filter(o => o[0] / 100 >= lo && o[0] / 100 <= hi);
  }
  function pricesInBudget(prices, lo, hi) {
    return (prices || []).filter(c => c / 100 >= lo && c / 100 <= hi).sort((a, b) => a - b);
  }
  function variantUrl(url, id) {
    if (!id) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(id);
  }

  // Each result carries the cheapest orderable option within the budget. "From" is shown only when the product
  // has more than one orderable price, so the shown price is always a real starting point that can be ordered.
  function recommend(products, who, occasion, budget) {
    const [lo, hi] = String(budget || '0-100000').split('-').map(Number);
    return products
      .map((p, i) => {
        const opts = options(p);
        const inBudget = optionsInBudget(opts, lo, hi);
        if (!inBudget.length) return null;
        const f = facets(p);
        const s = score(f, who, occasion);
        if (s <= 0) return null;
        const distinct = new Set(opts.map(o => o[0])).size;
        const pick = inBudget[0];
        return { p, s, i, price: pick[0], variant: pick[1], url: variantUrl(p.u, pick[1]), from: distinct > 1, f };
      })
      .filter(Boolean)
      .sort((a, b) => b.s - a.s || a.i - b.i);
  }

  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2), parts = two.split('.');
    const withSep = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const map = {
      amount: withSep(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: withSep(String(Math.round(n)), ','),
      amount_with_comma_separator: withSep(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: withSep(String(Math.round(n)), '.'),
      amount_with_apostrophe_separator: withSep(parts[0], "'") + '.' + parts[1]
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => map[k] !== undefined ? map[k] : map.amount);
  }

  const API = { facets, score, recommend, options, optionsInBudget, pricesInBudget, variantUrl, formatMoney, WHO, OCCASION };
  if (typeof module !== 'undefined' && module.exports) { module.exports = API; return; }
  root.MWGift = API;

  /* ---------- UI ---------- */
  function init(section) {
    let data;
    try { data = JSON.parse(section.querySelector('[data-gift-products]').textContent); } catch (e) { return; }
    const form = section.querySelector('[data-gift-form]'), grid = section.querySelector('[data-gift-grid]');
    const count = section.querySelector('[data-gift-count]'), more = section.querySelector('[data-gift-more]'), empty = section.querySelector('[data-gift-empty]'), emptyText = section.querySelector('[data-gift-empty-text]'), jump = section.querySelector('[data-gift-jump]');
    let shown = 6, last = [];
    const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const val = n => (form.querySelector('input[name="' + n + '"]:checked') || {}).value;

    function render() {
      last = recommend(data.products, val('who'), val('occasion'), val('budget'));
      grid.innerHTML = last.slice(0, shown).map(r => {
        const p = r.p;
        const price = (r.from ? 'From ' : '') + formatMoney(r.price, data.moneyFormat);
        const badges = [r.f.has('personalised') ? 'Personalised' : '', p.pt ? 'Production time: ' + esc(p.pt) : ''].filter(Boolean)
          .map(b => '<span class="mw-gift__badge">' + b + '</span>').join('');
        return '<li class="mw-gift__card"><a href="' + esc(r.url) + '">' +
          (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.a) + '" loading="lazy" width="600" height="600">' : '<span class="mw-gift__noimg" aria-hidden="true"></span>') +
          '<span class="mw-gift__name">' + esc(p.t) + '</span>' +
          '<span class="mw-gift__price">' + esc(price) + '</span>' +
          (badges ? '<span class="mw-gift__badges">' + badges + '</span>' : '') +
          '</a></li>';
      }).join('');
      const n = last.length;
      count.textContent = n ? (n === 1 ? '1 gift idea' : n + ' gift ideas') : 'No matches for these choices';
      if (jump) jump.textContent = n ? 'See ' + (n === 1 ? '1 gift idea' : n + ' gift ideas') : 'See suggestions';
      empty.hidden = n > 0;
      more.hidden = n <= shown;
      if (!n) {
        const label = name => { const el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.parentElement.textContent.trim() : ''; };
        emptyText.textContent = 'Nothing matches ' + [label('who'), label('occasion'), label('budget')].filter(Boolean).join(' · ') + ' right now.';
        const who = val('who'), occ = val('occasion'), bud = val('budget');
        const counts = {
          budget: bud === '0-100000' ? 0 : recommend(data.products, who, occ, '0-100000').length,
          occasion: occ === 'any' ? 0 : recommend(data.products, who, 'any', bud).length
        };
        counts.both = counts.budget || counts.occasion ? 0 : recommend(data.products, who, 'any', '0-100000').length;
        const names = { budget: 'Show any budget', occasion: 'Show any occasion', both: 'Show any budget and occasion' };
        section.querySelectorAll('[data-gift-widen]').forEach(b => {
          const k = b.dataset.giftWiden;
          b.hidden = !counts[k];
          if (!b.hidden) b.textContent = names[k] + ' (' + counts[k] + ')';
        });
      }
    }
    form.addEventListener('change', () => { shown = 6; render(); });
    more.addEventListener('click', () => { shown += 6; render(); const items = grid.querySelectorAll('a'); if (items[shown - 6]) items[shown - 6].focus(); });
    section.querySelectorAll('[data-gift-widen]').forEach(b => b.addEventListener('click', () => {
      const k = b.dataset.giftWiden;
      const set = (name, value) => { const input = form.querySelector('input[name="' + name + '"][value="' + value + '"]'); if (input) input.checked = true; };
      if (k === 'budget' || k === 'both') set('budget', '0-100000');
      if (k === 'occasion' || k === 'both') set('occasion', 'any');
      shown = 6; render(); count.setAttribute('tabindex', '-1'); count.focus();
    }));
    render();
  }
  const boot = () => document.querySelectorAll('.mw-gift').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : this);
